import { classList } from '@findigs/helpers/src/helpers/class-list';

export type DevErrorViewProps = {
  error: unknown;
  className?: string;
};

export const DevErrorView = ({ error, className }: DevErrorViewProps) => {
  const classes = classList(className, 'col-4 sm:col-12 md:col-16 lg:col-24');
  return (
    <div className={classes} style={{ width: '100%' }}>
      {error instanceof Error ? (
        <>
          <h1 className="text-t-md sm:text-t-lg mb-8">Error</h1>
          <p className="text-t-lg-medium">{error.message}</p>
          <p className="text-b-sm-regular">The stack trace is:</p>
          <pre style={{ fontSize: '.75rem', whiteSpace: 'pre-wrap' }}>
            {error.stack}
          </pre>
        </>
      ) : (
        <>
          <h1 className="text-t-md sm:text-t-lg mb-8">Unknown Error</h1>
          <p className="text-b-sm-regular">
            {JSON.stringify(error, null, '\t')}
          </p>
        </>
      )}
    </div>
  );
};
